import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';

export const CombinedFiltersSearchViewWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    gap: ${theme.spacing(1)};
    padding: ${theme.spacing(2)};
    box-shadow: ${theme.shadow.level7};
  `}
`;

export const CombinedFiltersSearchViewButton = styled.div<{ centeredContent?: boolean; grow?: boolean }>`
  ${({ theme, centeredContent = true, grow = false }) => `
    height: 48px;
    min-width: 48px;
    padding: ${theme.spacing(1)};
    display: flex;
    align-items: center;
    justify-content: ${centeredContent ? 'center' : 'flex-start'};
    flex-grow: ${+grow};
    border-radius: ${theme.borderRadius.large};
    border: 1px solid ${theme.colors.neutrals.grey6};
    svg {
      path {
        stroke: ${theme.colors.neutrals.grey1};
      }
    }
  `}
`;

export const CombinedFiltersSearchViewFiltersIconWrapper = styled.div<{ hasActiveFilters: boolean }>`
  margin-right: auto;
  flex-shrink: 0;
  height: 24px;
  padding-left: ${({ theme }) => theme.spacing(1)};
  padding-right: ${({ theme }) => theme.spacing(2)};
  svg {
    pointer-events: none;
  }
  ${({ theme, hasActiveFilters }) => hasActiveFilters ? `
    position: relative;
    &:after {
      content: '';
      position: absolute;
      height: 8px;
      width: 8px;
      background-color: ${theme.colors.brand.main};
      border: 3px solid ${theme.colors.neutrals.white};
      border-radius: 50%;
      top: -3px;
      right: 12px;
    }
  ` : ''}
`;

export const CombinedFiltersSearchViewInputPlaceholder = styled(Text)`
  color: ${({ theme }) => theme.colors.neutrals.grey4};
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

export const CombinedFiltersSearchViewSelectedLocations = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};
`;

export const CombinedFiltersSearchViewSelectedLocation = styled(Text)`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${theme.spacing(0.5)} ${theme.spacing(1)};
    background: ${theme.colors.neutrals.grey9};
    border-radius: ${theme.borderRadius.small};
    color: ${theme.colors.neutrals.grey1};
    height: 32px;
    min-width: 32px;
  `}
`;
